import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { TooltipEl } from "common/components/tooltip";
import { CopyType } from "./types";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".copy-to-clipboard-button"
  }, /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      ...this.attrs(),
      icon: this.attr(`icon`) || (this.attr(`copy-type`) === CopyType.Copy ? `copy` : `link`)
    },
    on: {
      click: this.helpers.copyValue
    }
  }, this.innerHTML.trim() && /* @__PURE__ */ jsx("slot", null)), /* @__PURE__ */ jsx(TooltipEl, {
    attrs: {
      "max-width": `64px`,
      text: `Copy`
    }
  }));
}
